import React, { useState } from "react";
import { Layout, Typography, Card, Row, Col, Button, Pagination, Tag, Tabs } from "antd";
import { AlertOutlined, SecurityScanOutlined, EyeOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const threatDetectionSolutions = [
    { id: 1, title: "AI-Based Intrusion Detection Systems (IDS)", category: "Threat Detection", difficulty: "Advanced", description: "AI-driven systems to monitor network traffic for malicious activity.", takenBy: 120 },
    { id: 2, title: "Anomaly Detection with Machine Learning", category: "Threat Detection", difficulty: "Intermediate", description: "AI models that detect abnormal patterns in data to identify potential threats.", takenBy: 150 },
    { id: 3, title: "Behavioral Analytics for Threat Detection", category: "Threat Detection", difficulty: "Advanced", description: "Analyzes user and entity behaviors to spot deviations and identify potential threats.", takenBy: 95 },
    { id: 4, title: "AI-Powered Malware Detection", category: "Threat Detection", difficulty: "Advanced", description: "Leverages machine learning to detect malicious software based on its behavior.", takenBy: 180 },
    { id: 5, title: "Phishing Detection with AI", category: "Threat Detection", difficulty: "Intermediate", description: "AI models designed to identify phishing attacks in emails and other communications.", takenBy: 110 },
    { id: 6, title: "AI-Based Ransomware Detection", category: "Threat Detection", difficulty: "Advanced", description: "Detects ransomware behavior patterns using advanced AI algorithms.", takenBy: 75 },
    { id: 7, title: "Threat Intelligence Platforms", category: "Threat Detection", difficulty: "Intermediate", description: "Integrates AI-driven threat intelligence to predict, detect, and respond to threats.", takenBy: 130 },
    { id: 8, title: "AI for Endpoint Detection and Response (EDR)", category: "Threat Detection", difficulty: "Advanced", description: "AI-powered endpoint security systems that respond to threats in real-time.", takenBy: 90 },

    // Two additional beginner solutions
    { id: 9, title: "Basic Phishing Detection Tools", category: "Threat Detection", difficulty: "Beginner", description: "Simple AI models to detect phishing emails based on keywords and known patterns.", takenBy: 60 },
    { id: 10, title: "Network Traffic Monitoring with AI", category: "Threat Detection", difficulty: "Beginner", description: "Basic machine learning tools to monitor network traffic and identify suspicious patterns.", takenBy: 45 }
];

const pageSize = 4;

function ThreatDetection() {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Intermediate");

    const filteredThreats = threatDetectionSolutions.filter(threat => threat.difficulty === activeTab);
    const paginatedThreats = filteredThreats.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>AI Threat Detection Solutions</Title>
                <Paragraph>Explore cutting-edge AI-powered threat detection solutions designed to protect your systems from malicious attacks and security breaches.</Paragraph>

                <Tabs activeKey={activeTab} onChange={key => { setActiveTab(key); setCurrentPage(1); }} centered>
                    <TabPane tab="Beginner" key="Beginner" />
                    <TabPane tab="Intermediate" key="Intermediate" />
                    <TabPane tab="Advanced" key="Advanced" />
                </Tabs>

                <Row gutter={[16, 16]}>
                    {paginatedThreats.map((threat) => (
                        <Col xs={24} sm={12} md={6} key={threat.id}>
                            <Card hoverable>
                                <Title level={5}>{threat.title}</Title>
                                <Tag color="blue">{threat.category}</Tag>
                                <Tag color={threat.difficulty === "Beginner" ? "green" : threat.difficulty === "Intermediate" ? "gold" : "red"}>
                                    {threat.difficulty}
                                </Tag>
                                <Paragraph>{threat.description}</Paragraph>
                                <Paragraph><SecurityScanOutlined /> {threat.takenBy} instances detected</Paragraph>
                                <Button type="primary">Learn More</Button>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Pagination
                    current={currentPage}
                    total={filteredThreats.length}
                    pageSize={pageSize}
                    onChange={setCurrentPage}
                    style={{ marginTop: "20px", textAlign: "center" }}
                />
            </Content>
        </Layout>
    );
}

export default ThreatDetection;
